import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, XCircle } from 'lucide-react';
const isFor = ['Padres y madres separados que conviven con un ex conflictivo o manipulador.', 'Personas que sienten que su salud mental depende del humor de la otra persona.', 'Padres que quieren proteger la estabilidad emocional de sus hijos por sobre todas las cosas.', 'Quienes están cansados de que una notificación de WhatsApp les arruine el fin de semana.'];
const notFor = ['Parejas con un divorcio amigable donde la comunicación fluye sin problemas.', 'Personas que todavía buscan usar el conflicto para seguir vinculados emocionalmente con su ex.', 'Quienes no están dispuestos a dejar de tener la "última palabra" en favor de su propia paz.'];
export function WhoIsThisFor() {
  return <section className="bg-navy py-24 px-6" data-id="element-312">
      <div className="max-w-4xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-313">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-314">
          <h3 className="font-playfair text-2xl font-bold text-white mb-8 border-b-2 border-green-200/30 pb-4" data-id="element-315">
            ESTO ES PARA VOS SI...
          </h3>
          <ul className="space-y-6" data-id="element-316">
            {isFor.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-317">
                <CheckCircle2 className="w-6 h-6 text-green-500 flex-shrink-0 mt-0.5" data-id="element-318" />
                <span className="text-slate-200 font-medium leading-relaxed" data-id="element-319">
                  {item}
                </span>
              </li>)}
          </ul>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} data-id="element-320">
          <h3 className="font-playfair text-2xl font-bold text-white mb-8 border-b-2 border-red-200/30 pb-4" data-id="element-321">
            ESTO NO ES PARA VOS SI...
          </h3>
          <ul className="space-y-6" data-id="element-322">
            {notFor.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-323">
                <XCircle className="w-6 h-6 text-red-500 flex-shrink-0 mt-0.5" data-id="element-324" />
                <span className="text-slate-300 leading-relaxed" data-id="element-325">{item}</span>
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}